export interface ParsedSessionDateRange {
  startDate: string;
  endDate: string;
}

/**
 * Parse a `YYYY-MM-DD to YYYY-MM-DD` display range (optionally with a time
 * component on either end, and with `to` / en dash / em dash as the separator)
 * into its two date-only halves. Returns `undefined` when the value is not a
 * range — callers fall back to single-date parsing.
 *
 * Purely lexical: no timezone, no locale, no `Date` construction.
 */
export const parseSessionDateRange = (
  value: string | undefined
): ParsedSessionDateRange | undefined => {
  const match = value?.match(
    /^(\d{4}-\d{2}-\d{2})(?:T[^\s]+)?\s+(?:to|\u2013|\u2014)\s+(\d{4}-\d{2}-\d{2})(?:T[^\s]+)?$/u
  );
  if (!match?.[1] || !match[2]) return undefined;
  return { startDate: match[1], endDate: match[2] };
};
